import { render, staticRenderFns } from "./CollectLisapay.vue?vue&type=template&id=6cc4eb59&"
import script from "./CollectLisapay.vue?vue&type=script&lang=js&"
export * from "./CollectLisapay.vue?vue&type=script&lang=js&"
import style0 from "./CollectLisapay.vue?vue&type=style&index=0&id=6cc4eb59&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports